function routerReducer(state = {}, action = {}) {
  switch (action.type) {
    case 'UPDATE_ROUTER_LOCATION':
      return {
        ...state,
        location: { ...action.location },
        match: { ...state.match, url: action.location.pathname }
      }
    case 'UPDATE_ROUTER_PARAMS':
      return {
        ...state,
        match: { ...state.match, params: { ...action.params } }
      }
    case 'UPDATE_ROUTER_QUERY':
      return {
        ...state,
        match: { ...state.match, query: { ...action.query } }
      }
    default:
      return state
  }
}

export default routerReducer
